import React from 'react';

function Chat() {
  return (
    <section className="tc-chat-style1">
      <div className="container">
        <div className="content">
          <a href="tel:8754505413" className="xl-text js-splittext-lines" >
           8754505413
          </a>
          <h5 className="mb-50 lh-5">
            Let us help your dream <br /> become reality
          </h5>
        </div>
      </div>
      <img
        src="/innerpages/assets/img/c_line4.png"
        alt=""
        className="c-line wow"
      />
    </section>
  );
}

export default Chat;
